
function openAddedDrawer(data) {
    const drawer = document.getElementById("added-to-cart-drawer");
    if (!drawer) return;
    //console.log("drawer", document.getElementById("added-to-cart-drawer"))
    const items = data.items || [data];  // Maneja array o single
    const productContainer = drawer.querySelector(".added-drawer__content");
    const template = drawer.querySelector(".added-product").cloneNode(true);  // Clona el template original
    const actions = drawer.querySelector(".added-drawer__actions");

    // Limpia productos previos (excepto header y actions)
    productContainer.querySelectorAll(".added-product").forEach(el => el.remove());

    const firstItem = items[0];

    if (firstItem?.product_id) {
      loadRecommendations(firstItem.product_id);
    }
    items.forEach(item => {
      const clone = template.cloneNode(true);

      // Nombre
      clone.querySelector(".added-product-name").textContent = item.product_title || item.title;

      // Tipo de producto
      let productType = "Producto";

      // Detectar desde variant (caso bikini/set)
      const optionValue = item.variant_options?.[0]?.toLowerCase();
      const variantTitle = (item.variant_title || "").toLowerCase();

      const isTop = optionValue === "top" || variantTitle.includes("top");
      const isBottom = optionValue === "bottom" || variantTitle.includes("bottom");

      if (isTop) {
        productType = "Top";
      } else if (isBottom) {
        productType = "Bottom";
      } else {
        // fallback para productos normales
        const baseType = (item.product_type || "").toLowerCase();

        if (baseType === "one piece") {
          productType = "Una pieza";
        } else {
          productType = item.product_type || "Producto";
        }
      }

      clone.querySelector(".added-product-type").textContent = "Tipo: " + productType;

      // Talla (asumiendo primera opción)
      const size = item.variant_options?.[1] 
            || item.options_with_values?.find(o => o.name === "Talla")?.value 
            || '';
      clone.querySelector(".added-product-size").textContent = "Talla: " + size;

      // Imagen fallback
      clone.querySelector(".added-product-image").src = item.image || '';

      // Precios con lógica
      let compareText = '';
      let priceText = formatMoney(item.final_price || item.original_price || item.price);

      const originalPrice = item.original_price || item.price;
      const finalPrice = item.final_price || originalPrice;

      if (originalPrice !== finalPrice) {
        compareText = `<s>${formatMoney(originalPrice)}</s>`;
        priceText = formatMoney(finalPrice);
      }
      clone.querySelector(".added-product-compare").innerHTML = compareText;
      clone.querySelector(".added-product-price").textContent = priceText;

      // Fetch para imagen y compare_at_price (por item)
      if(item.handle){
      fetch(`/products/${item.handle}.json`)
            .then(r => r.json())
            .then(productData => {
              const product = productData.product;
              if (product) {
                // Lógica de imagen
                if (product.images && product.images.length > 0) {
                  let selectedImage = product.images[0]?.src;

                  // Detectar desde variant (caso bikini/set)
                  const optionValue = item.variant_options?.[0]?.toLowerCase();
                  const variantTitle = (item.variant_title || "").toLowerCase();

                  const isTop = optionValue === "top" || variantTitle.includes("top");
                  const isBottom = optionValue === "bottom" || variantTitle.includes("bottom");

                  if (isTop) {
                    selectedImage = product.images[0]?.src;
                  } else if (isBottom) {
                    selectedImage = product.images[1]?.src || product.images[0]?.src;
                  } else {
                    // Producto normal (no set)
                    selectedImage = product.images[0]?.src;
                  }

                  clone.querySelector(".added-product-image").src = selectedImage;
                }

                // Compare price
                const variantId = item.variant_id || item.id

                const variant = product.variants.find(v => v.id == variantId)
                if (variant && variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
                  const compareAtCents = parseFloat(variant.compare_at_price) * 100;
                  if (originalPrice === finalPrice) {
                    compareText = `<s>${formatMoney(compareAtCents)}</s>`;
                    clone.querySelector(".added-product-compare").innerHTML = compareText;
                  }
                }
                
              }
            })
            .catch(err => console.error('Error fetching product:', err));
          }
          // Inserta el clone antes de actions
          productContainer.insertBefore(clone, actions);
    });
        drawer.classList.add("active");
        document.body.classList.add('overflow-hidden');
}

  function loadRecommendations(productId) {
    const container = document.getElementById("drawer-recommendations");
    if (!container) return;
    fetch(`/recommendations/products?section_id=drawer-recommendations&product_id=${productId}&limit=6&intent=related`)
      .then(res => res.text())
      .then(html => {
      const doc = new DOMParser().parseFromString(html, "text/html");
    console.log(html);

      // intenta encontrar el bloque completo
      const recommendationsBlock = doc.querySelector("product-recommendations");

      if (!recommendationsBlock) {
        container.innerHTML = "";
        return;
      }

      // inyecta todo el HTML
      container.innerHTML = `
        <div >
          <h3 style="color: #474747; font-family: BodoniFLF; font-size: 16px; font-style: italic; font-weight: 500; line-height: 150%; padding: 0 16px 8px 16px; margin: 0;">Te puede gustar</h3>
        </div>
      `;

      container.appendChild(recommendationsBlock);
      })
      .catch(err => console.error("Error recommendations:", err));
  }

  function formatMoney(cents){

    return new Intl.NumberFormat("es-CO",{
    style:"currency",
    currency:"COP",
    minimumFractionDigits:0
    }).format(cents/100)

  }

document.addEventListener("click", e => {

  const drawer = document.getElementById("added-to-cart-drawer");

  if(
    e.target.closest(".added-drawer__close") ||
    e.target.classList.contains("added-drawer__overlay")
  ){
      drawer.classList.remove("active");
      document.body.classList.remove('overflow-hidden');
  }

  if(e.target.closest(".go-cart")){
      const cartDrawer = document.querySelector("cart-drawer");
      if(cartDrawer){
        cartDrawer.open();
      }
  }

  });


